import * as alarms from "./alarms";
import * as banners from "./banners";
import * as emails from "./emails";
import * as logos from "./logos";
import * as receptions from "./receptions";
import * as setting from "./setting";
import * as partners from "./partners";
import * as popups from "./popups";

export const common = {
    ...alarms,
    ...banners,
    ...emails,
    ...logos,
    ...receptions,
    ...setting,
    ...partners,
    ...popups,
}
